import { ApiAnonymousService } from "./apiService";
import { ENDPOINTS } from "../config/apiConfig";

export interface Comp {
  id: number;
  firstName: string;
  lastName: string;
}

export interface Competition {
  resultsPublished?: boolean;
  id: number;
  name: string;
  competitionDate: string;
  location: string;
  type: string;
  description?: string;
  leagueId?: number;
  leagueName?: string;
  urlLocandina?: string;
}

export interface League {
  id: number;
  name: string;
  year: string;
  description: string;
  discipline: number;
}

export interface Paged<T> {
  results: T[];
  totalPages: number;
  pageSize: number;
  pageNumber: number;
  totalResults: number;
}

export interface Statistics {
  totalWeightKg?: number;
  totalPoints: number;
  totalFish: number;
  competitionsCount: number;
  firstPlaces: number;
  secondPlaces: number;
  thirdPlaces: number;
  pointLeague?: number;
  positionLeague?: number;
}

export class PublicApiService {
  static async getCompetitors(discipline: number = 1): Promise<Comp[]> {
    return ApiAnonymousService.client.get<Comp[]>(
      `${ENDPOINTS.PUBLIC.GET_COMPETITORS}?discipline=${discipline}`
    );
  }

  static async getLeagues(discipline: number = 1): Promise<Paged<League>> {
    return ApiAnonymousService.client.get<Paged<League>>(
      `${ENDPOINTS.PUBLIC.LEAGUES}?discipline=${discipline}`
    );
  }

  static async getRanking(
    competitorId: number,
    leagueId?: number | null,
    year?: string | null,
    discipline: number = 1
  ): Promise<Statistics> {
    const params = new URLSearchParams({ discipline: String(discipline) });
    if (leagueId) {
      params.append("leagueId", String(leagueId));
    }
    if (year) {
      params.append("year", year);
    }

    return ApiAnonymousService.client.get<Statistics>(
      `${ENDPOINTS.PUBLIC.STATISTICS(competitorId)}?${params.toString()}`
    );
  }

  static async getCompetitions(
    pageNumeber?: number,
    pageSize?: number | null,
    orderBy?: string | null,
    desc?: boolean | null,
    discipline: number = 1
  ): Promise<Paged<Competition>> {
    const params = new URLSearchParams({ discipline: String(discipline) });
    if (pageNumeber) {
      params.append("pageNumber", String(pageNumeber));
    }
    if (pageSize) {
      params.append("pageSize", String(pageSize));
    }
    if (orderBy) {
      params.append("orderBy", orderBy);
    }
    if (desc) {
      params.append("desc", String(desc));
    }

    return ApiAnonymousService.client.get<Paged<Competition>>(
      `${ENDPOINTS.PUBLIC.COMPETITIONS}?${params.toString()}`
    );
  }

  static async getLeaderboard(competitionId: number): Promise<any> {
    return ApiAnonymousService.client.get<any>(
      ENDPOINTS.PUBLIC.LEADERBOARD(competitionId)
    );
  }

  static async getCampionatoRanking(leagueId: number): Promise<any> {
      return ApiAnonymousService.client.get<any>(ENDPOINTS.PUBLIC.GET_RANKING(leagueId));
    }
}
